// Firebase Config
export const APIKEY  = 'AIzaSyBf2j-TEJN-howHUOjK_xfpzBFfmnCCeK4';
export const AUTH_DOMAIN  = 'stagingapp2soft.firebaseapp.com';
export const DATABASE_URL  = 'https://stagingapp2soft.firebaseio.com';
export const PROJECT_ID  = 'stagingapp2soft';
export const STORAGE_BUCKET  = 'stagingapp2soft';
export const MESSAGING_SENDER_ID  = 'stagingapp2soft';

export const FIREBASE_CONFIG = {
    apiKey: 		APIKEY,
    authDomain: 	AUTH_DOMAIN,
    databaseURL: 	DATABASE_URL,
    projectId: 		PROJECT_ID,
    storageBucket: 	STORAGE_BUCKET,
    messagingSenderId: MESSAGING_SENDER_ID
};




// WEBPACK FOOTER //
// ./src/constants/FirebaseConfig.js